import { useState, useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import ScrollToTop from "@/components/base/ScrollToTop";

const testimonials = [
  {
    name: "黄小雯",
    role: "美食部落客 / 5万粉丝",
    content: "Po文完全指南彻底改变了我的内容创作方式。以前我的po文互动率只有0.3%左右，按照指南里的排版和标题技巧调整后，现在稳定在1.5%以上。推荐给每一位内容创作者！",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20warm%20smile%20minimalist%20clean%20background%20editorial%20photography%20soft%20natural%20light&width=200&height=200&seq=testimonial-1&orientation=squarish",
    rating: 5,
  },
  {
    name: "刘志明",
    role: "个人品牌教练 / 2万粉丝",
    content: "作为一个教别人打造个人品牌的人，我一直在寻找高质量的中文内容创作资源。这个网站的内容深度和实用性都超出了我的预期，特别是数据分析相关的文章，非常有见地。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20warm%20expression%20minimalist%20clean%20background%20editorial%20photography%20soft%20natural%20light&width=200&height=200&seq=testimonial-2&orientation=squarish",
    rating: 5,
  },
  {
    name: "陈思妤",
    role: "自由接案设计师 / 8千粉丝",
    content: "我特别喜欢网站上关于po文排版的文章！作为一个设计师，排版是我最在意的事情，但之前不知道如何将设计思维运用到社交媒体内容中。这些文章给了我很多灵感。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20confident%20smile%20minimalist%20clean%20background%20editorial%20photography%20soft%20natural%20light&width=200&height=200&seq=testimonial-3&orientation=squarish",
    rating: 5,
  },
  {
    name: "吴建宏",
    role: "电商经营者 / 1.5万粉丝",
    content: "最佳发布时机的文章帮我在实际运营中节省了大量的测试时间。按照建议的时间表调整后，我的产品宣传po文触及率提高了大约80%。非常实用的指南！",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20friendly%20expression%20minimalist%20clean%20background%20editorial%20photography%20soft%20natural%20light&width=200&height=200&seq=testimonial-4&orientation=squarish",
    rating: 4,
  },
];

const FORM_SUBMIT_URL = "https://readdy.ai/api/form/d9squj14ne17ei0sdmf0";

export default function AboutPage() {
  const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });
  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  useEffect(() => {
    document.title = "关于我们 - Po文完全指南";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", "了解Po文完全指南背后的团队与理念。我们致力于为中文创作者提供最实用的po文技巧、排版方法和内容策略，帮助每一位创作者被更多人看见。");
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) metaKw.setAttribute("content", "关于我们,po文指南,品牌介绍,内容创作,联系方式");
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeyVal = (fd.get("company_alt") as string || "").trim();
    if (honeyVal) {
      setFormStatus("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
      return;
    }
    fd.delete("company_alt");

    try {
      const res = await fetch(FORM_SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (res.ok && parsed?.code === "OK") {
        setFormStatus("success");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || "";
        setFormStatus("error");
        setFormError(serverMsg || "发送失败，请稍后再试");
      }
    } catch {
      setFormStatus("error");
      setFormError("网络错误，请检查连接后重试");
    }
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Po文完全指南",
    url: "https://powen.guide",
    description: "最全面的中文Po文创作指南，提供po文标题撰写、内容排版、最佳发布时机等完整策略。",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "(02) 2722-0000",
      contactType: "customer service",
      email: "hello@powen.guide",
    },
    address: {
      "@type": "PostalAddress",
      addressLocality: "台北市",
      addressRegion: "信义区",
      addressCountry: "TW",
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://powen.guide" },
      { "@type": "ListItem", position: 2, name: "关于我们" },
    ],
  };

  const breadcrumbItems = [
    { label: "首页", href: "/" },
    { label: "关于我们" },
  ];

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-24 pb-16 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumbItems} />

          <section className="mt-8">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4">
                关于我们
              </span>
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-900 mb-4"
                style={{ fontFamily: "var(--font-heading)" }}>
                让每一篇Po文都被看见
              </h1>
              <p className="text-foreground-600 leading-relaxed text-sm">
                Po文完全指南创立于2024年，是中文世界最全面的社交媒体内容创作指南平台。
                我们相信，每个人都有值得被看见的声音——而好的po文技巧，就是让这些声音被放大的关键。
                从标题撰写、内容排版到发布策略，我们致力于帮助每一位创作者，让优质内容不再被算法埋没。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20">
              <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className="ri-eye-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-bold text-foreground-900 mb-2">我们的使命</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  让每一位中文创作者都能掌握专业的po文技巧，在信息洪流中找到属于自己的声音和受众。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className="ri-team-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-bold text-foreground-900 mb-2">我们的团队</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  由资深内容创作者、数据分析师和视觉设计师组成的专业团队，持续产出高质量内容。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-bold text-foreground-900 mb-2">内容理念</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  所有内容都基于真实数据和实战经验，拒绝空谈理论，追求可操作、可验证的实用价值。
                </p>
              </div>
            </div>
          </section>

          <section className="mb-20">
            <div className="text-center mb-12">
              <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4">
                用户口碑
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900"
                style={{ fontFamily: "var(--font-heading)" }}>
                创作者怎么说
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {testimonials.map((t, i) => (
                <div key={i} className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <i
                        key={j}
                        className={`text-sm ${j < t.rating ? "ri-star-fill text-accent-500" : "ri-star-fill text-foreground-300"}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{t.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="max-w-2xl mx-auto">
            <div className="text-center mb-10">
              <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4">
                联系我们
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900"
                style={{ fontFamily: "var(--font-heading)" }}>
                有什么想说的？
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                无论是建议、合作还是任何问题，都欢迎透过下方表单与我们联系
              </p>
            </div>

            <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
              {formStatus === "success" ? (
                <div className="text-center py-8">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-check-line text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-foreground-900 mb-2">消息已发送！</h3>
                  <p className="text-sm text-foreground-600">
                    感谢你的来信，我们会尽快回复。
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} data-readdy-form>
                  <input
                    type="text"
                    name="company_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="absolute opacity-0 pointer-events-none"
                    style={{ position: "absolute", left: "-9999px" }}
                  />
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        姓名
                      </label>
                      <input
                        id="contact-name"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
                        placeholder="你的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        电子邮箱
                      </label>
                      <input
                        id="contact-email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      主题
                    </label>
                    <input
                      id="contact-subject"
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
                      placeholder="想讨论的主题"
                    />
                  </div>
                  <div className="mb-5">
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      内容
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300/60 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all resize-none"
                      placeholder="请输入你的消息（最多500字）"
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1 text-right">{formData.message.length}/500</p>
                  </div>
                  <button
                    type="submit"
                    className="w-full py-3 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
                  >
                    发送消息
                  </button>
                  {formStatus === "error" && (
                    <p className="mt-3 text-sm text-red-500">{formError}</p>
                  )}
                </form>
              )}
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/70">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-mail-line"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">电子邮箱</p>
                <a href="mailto:hello@powen.guide" className="text-sm font-semibold text-foreground-900 hover:text-primary-500 transition-colors">
                  hello@powen.guide
                </a>
              </div>
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/70">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-map-pin-line"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">地址</p>
                <p className="text-sm font-semibold text-foreground-900">台湾台北市信义区</p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/70">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-phone-line"></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">电话</p>
                <a href="tel:+886227220000" className="text-sm font-semibold text-foreground-900 hover:text-primary-500 transition-colors">
                  (02) 2722-0000
                </a>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />

      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
    </>
  );
}